import { render, staticRenderFns } from "./load_success_btn.vue?vue&type=template&id=0bf4603d&scoped=true"
import script from "./load_success_btn.vue?vue&type=script&lang=js"
export * from "./load_success_btn.vue?vue&type=script&lang=js"
import style0 from "./load_success_btn.vue?vue&type=style&index=0&id=0bf4603d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf4603d",
  null
  
)

export default component.exports